import { BuildingInfoType } from 'types/property.type';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { LocalStorage, STORAGE_KEY } from 'utils/localStorage';

const Storage = new LocalStorage();

interface State {
  buildings: BuildingInfoType[];
  currentBuilding?: BuildingInfoType;
}

const initialState: State = {
  buildings: [],
};

const propertySlice = createSlice({
  name: 'property',
  initialState,
  reducers: {
    setCurrentBuilding: (state: State, action: PayloadAction<BuildingInfoType>) => {
      state.currentBuilding = action.payload;
      Storage.setStorageItem(STORAGE_KEY.BUILDING_ID, action.payload.id);
    },
  },

  // extraReducers: (builder) => {},
});

export const { setCurrentBuilding } = propertySlice.actions;
export default propertySlice.reducer;
